import { useEffect } from 'react'

interface SEOProps {
  title: string
  description: string
  canonical?: string
  ogImage?: string
  ogType?: string
}

export const useSEO = ({
  title,
  description,
  canonical,
  ogImage = 'https://cdn.magicpatterns.com/uploads/c7DtgUV4minxineBKqyaMP/IMG_2681-PROOF-THOMAS-MASOTTI.jpg',
  ogType = 'website',
}: SEOProps) => {
  useEffect(() => {
    // Set title
    document.title = title

    // Helper to set meta tags
    const setMetaTag = (attr: string, key: string, content: string) => {
      let tag = document.querySelector(
        `meta[${attr}="${key}"]`,
      ) as HTMLMetaElement
      if (!tag) {
        tag = document.createElement('meta')
        tag.setAttribute(attr, key)
        document.head.appendChild(tag)
      }
      tag.content = content
    }

    // Set standard meta
    setMetaTag('name', 'description', description)

    // Set canonical
    if (canonical) {
      let link = document.querySelector(
        'link[rel="canonical"]',
      ) as HTMLLinkElement
      if (!link) {
        link = document.createElement('link')
        link.rel = 'canonical'
        document.head.appendChild(link)
      }
      link.href = canonical
    }

    // Set OG tags
    setMetaTag('property', 'og:title', title)
    setMetaTag('property', 'og:description', description)
    setMetaTag('property', 'og:image', ogImage)
    setMetaTag('property', 'og:type', ogType)
    if (canonical) setMetaTag('property', 'og:url', canonical)

    // Set Twitter tags
    setMetaTag('name', 'twitter:title', title)
    setMetaTag('name', 'twitter:description', description)
    setMetaTag('name', 'twitter:image', ogImage)
  }, [title, description, canonical, ogImage, ogType])
}
